module.exports = __webpack_public_path__ + "img/lunbo242.edbbd6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/lunbo242.png
// module id = QKok
// module chunks = 0